var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 173,
    viewBox: "0 0 150 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0912 0H46.5592C51.5726 0 55.6603 4.15381 55.6603 9.11668V163.893C55.6603 168.856 51.5332 173 46.5592 173H9.0912C4.13684 173 0 168.896 0 163.893V9.11668C0 4.09461 4.08759 0 9.0912 0ZM103.421 0H140.909C145.912 0 150 4.14394 150 9.11668V163.893C150 168.856 145.873 173 140.909 173H103.421C98.4569 173 94.3299 168.896 94.3299 163.893V9.11668C94.3299 4.09461 98.4273 0 103.421 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseicon);
export default __webpack_public_path__ + "static/media/pauseicon.1273390e.svg";
export { ForwardRef as ReactComponent };